import { queryOptions } from "@tanstack/react-query";

import { getJoinState } from "@/modules/coaching/join/services/getJoinState";
import { ONE_MINUTE } from "@/modules/shared/consts/time";
import { isFetchNetworkError } from "@/modules/shared/utils/reactQueryErrorTracking";

/**
 * Query keys for join state operations
 */
export const joinStateKeys = {
  root: ["joinState"] as const,
  byCode: (code: string) => [...joinStateKeys.root, code] as const,
};

export const getJoinStateQuery = (code: string) =>
  queryOptions({
    queryKey: joinStateKeys.byCode(code),
    queryFn: () => getJoinState(code),
    staleTime: 0,
    gcTime: 10 * ONE_MINUTE,
    networkMode: "always",
    retry: (failureCount, error) =>
      failureCount < 2 && isFetchNetworkError(error),
    retryDelay: 1000,
  });
